import React, { useState } from 'react';
import { Card, Row, Col, List, Select, DatePicker, Spin, Space } from 'antd';
import Background from '../../../../../static/img/bg-list-title.png';
import Client from '../../../../../lib/gqlClient';
import moment from 'moment-timezone';
import { queryAppVersionList, queryAppReviewsList } from '../gqls'
import { useNavigate ,useLocation} from 'react-router-dom';
const CommentsListPage = (props) => {
    const location = useLocation()
    const { state } = location
    const navigate = useNavigate();
    const [isGetData, setIsGetData] = useState(false)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(1)
    const [dataList, setDataList] = useState([])
    const { RangePicker } = DatePicker;

    const [isSelectVersionListLoading, setIsSelectVersionListLoading] = useState(false)//是否正在加载
    const [versionList, setVersionList] = useState([])
    const [version, setVersion] = useState('All version')

    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [startTimeString, setStartTimeString] = useState('')
    const [endTimeString, setEndTimeString] = useState('')

    const [defaultValue, setDefaultValue] = useState([])

    const [showSize, setShowSize] = useState(8)
    React.useEffect(() => {
        getAppVersionList()
        if(state!=null){
            setPage(state.page)
            setShowSize(state.showSize)
            setVersion(state.version)
            if(state.startTimeString!==''&&state.endTimeString!==''){
                setDefaultValue([moment(state.startTimeString, 'YYYY-MM-DD'), moment(state.endTimeString, 'YYYY-MM-DD')])
            }
            getAppReviewsList(state.page, state.showSize, state.version,state.startTime,state.endTime)
        }else{
            getAppReviewsList(1, showSize, version)
        }
    }, [])

    function getAppVersionList(){
        setIsSelectVersionListLoading(true)
        Client(
            queryAppVersionList,
            {
                app: 'ig',
            }
        ).then((res) => {
            if (res !== null) {
                let data = [{}];
                const list = res.data.appVersionList
                data[0] = 'All version'
                for (let index = 0; index < res.data.appVersionList.length; index++) {
                    const element = res.data.appVersionList[index];
                    data[index+1] = element
                }
                setVersionList(data)
                
            }
            setIsSelectVersionListLoading(false)
        }).catch(e => {
            // console.log(e);
            setIsSelectVersionListLoading(false)
        })
    }
    function getAppReviewsList(page, count, version, startTime, endTime) {
        let thisVersion=''
        if(version===''||version==='All version'){
            thisVersion=''
        }else{
            thisVersion=version
        }
        setIsGetData(true)
        if (count !== showSize) {
            setShowSize(count)
        }
        setPage(page)
        Client(
            queryAppReviewsList,
            {
                app: 'ig',
                page: page,
                count: count,
                platform: 'IOS',
                version: thisVersion,
                startDate: startTime,
                endDate: endTime
            }
        ).then((res) => {
            if (res !== null) {
                setDataList(res.data.appReviewsList.data)
                setTotal(res.data.appReviewsList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }

    function onClick(data) {
        navigate('/developerCenter/scoreOrComments/commentsContentData', {
            replace: false,
            state: {
                userName: data.userName,
                score: data.score,
                region: data.region,
                appVersion: data.appVersion,
                createdAt: data.createdAt,
                title: data.title,
                content: data.content,
                replyDate: data.replyDate,
                replyText: data.replyText,
                app: 'iGluco',
                platform: 'ios',

                version: version,

                startTime: startTime,
                endTime: endTime,
                startTimeString: startTimeString,
                endTimeString: endTimeString,
                
                page: page,
                showSize: showSize,
            }
        })
    }
    //选择设备类型
    function handleChange(e) {
        setVersion(e)
        getAppReviewsList(1, showSize, e, startTime, endTime)
    }
    function onChange(date, dateString) {
        console.log(date, dateString);
        setDefaultValue(date)
        setStartTimeString(dateString[0])
        setEndTimeString(dateString[1])
        if(date!=null){
            const start = moment(date[0]).valueOf()
            const end = moment(date[1]).valueOf()
            setStartTime(start)
            setEndTime(end)
            getAppReviewsList(1, showSize, version, start, end)
        }else{
            setStartTime('')
            setEndTime('')
            getAppReviewsList(1, showSize, version)
        }
    }
    return (
        <Card bordered={false} style={{ marginTop: '20px', marginBottom: '22px', padding: '0px', }}>
            <div style={Styles.listTitle}>评论列表</div>
            <Row style={{marginBottom: '10px',}}>
                <Col span={24} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                    <Spin size="large" tip="Loading..." spinning={isSelectVersionListLoading}>
                        <Select value={version} style={{ width: '123px', marginRight: '10px' }}
                           
                            onChange={(e) => {
                                handleChange(e)
                            }}>
                            {versionList.map(it => (
                                <Select.Option value={it}>
                                    {it}
                                </Select.Option>
                            ))}
                        </Select>
                    </Spin>
                    <RangePicker value={defaultValue} onChange={onChange} style={{ height: '32px', width: '256px', marginRight: '32px', }} />
                </Col>
            </Row>
            <Row style={Styles.listTitleBg}>
                <Col span={3} style={Styles.listTitleText}>
                    UserName
                </Col>
                <Col span={2} style={Styles.listTitleText}>
                    Score
                </Col>
                <Col span={2} style={Styles.listTitleText}>
                    Region/Languane
                </Col>
                <Col span={3} style={Styles.listTitleText}>
                    App Version
                </Col>
                <Col span={6} style={Styles.listTitleText}>
                    Content
                </Col>
                <Col span={4} style={Styles.listTitleText}>
                    Create Time
                </Col>
                <Col span={3} style={Styles.listTitleText}>
                    Operation
                </Col>
            </Row>
            <Spin size="large" tip="Loading..." spinning={isGetData}>

                <List
                    itemLayout="vertical"
                    split="true"
                    pagination={{
                        onChange: (page, pageSize) => {
                            setPage(page)
                            getAppReviewsList(page, pageSize, version, startTime, endTime)
                        },

                        pageSize: showSize,
                        hideOnSinglePage: true,
                        pageSizeOptions: [8, 10, 15, 20, 30, 50, 80, 100],
                        current: page,
                        total: total
                    }}
                    position="bottom"
                    dataSource={dataList}
                    renderItem={(item) => (
                        <List.Item>
                            <Row style={Styles.item}>
                                <Col span={3} style={Styles.listTitleText}>
                                    {item.userName}
                                </Col>
                                <Col span={2} style={Styles.listTitleText}>
                                    {item.score}
                                </Col>
                                <Col span={2} style={Styles.listTitleText}>
                                    {item.region}
                                </Col>
                                <Col span={3} style={Styles.listTitleText}>
                                    {item.appVersion}
                                </Col>
                                <Col span={6} style={Styles.listTitleText}>
                                    {item.content}
                                </Col>
                                <Col span={4} style={Styles.listTitleText}>
                                    {item.createdAt.substring(0, 10)}
                                </Col>
                                <Col span={3} style={Styles.listTitleText}>
                                    <a onClick={() => onClick(item)}>
                                        <Space>
                                            View
                                        </Space>
                                    </a>
                                </Col>
                            </Row>
                        </List.Item>
                    )}
                />
            </Spin>
        </Card>
    );

}

const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    listTitleText: {
        fontSize: '14px',
        lineHeight: '22px',
        textAlign: 'center',
    },
    item: {
        minEight: '54px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
}
export default CommentsListPage